<ng-container *ngIf="!isLoading">
  <ng-container *ngIf="newRecipientModel.currentStep === step.STEP1">
    <np-add-new-recipient-step-1 [action]="action"></np-add-new-recipient-step-1>
  </ng-container>

  <ng-container *ngIf="newRecipientModel.currentStep === step.STEP2">
    <np-add-new-recipient-step-2 [action]="action" [bankDto]="bankDto"></np-add-new-recipient-step-2>
  </ng-container>

  <ng-container *ngIf="newRecipientModel.currentStep === step.Authy">
    <np-add-new-recipient-verify-code [action]="action" (submited)="updatePartnerBank()"></np-add-new-recipient-verify-code>
  </ng-container>
</ng-container>